import produce from "immer"
import { InferValueTypes } from "client/utils"
import { initSilProjectDevice } from "client/store"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initSilUpdateState: types.SilUpdateState = {
    device: {
        targetDevice: initSilProjectDevice,
        originDevice: initSilProjectDevice,
    },

    subsystem: {
        targetDevice: initSilProjectDevice,
        originDevice: initSilProjectDevice,
    },
}

const silUpdateReducer = produce((
    draft: types.SilUpdateState = initSilUpdateState,
    action: ActionTypes = null,
): types.SilUpdateState => {
    switch (action.type) {
        case types.SIL_UPDATE_DEVICE_TARGET_DEVICE:
            draft.device.targetDevice = action.device
            return draft

        case types.SIL_UPDATE_DEVICE_ORIGIN_DEVICE:
            draft.device.originDevice = action.device
            return draft

        case types.SIL_UPDATE_DEVICE_TARGET_SUBSYSTEM:
            draft.subsystem.targetDevice = action.device
            return draft

        case types.SIL_UPDATE_DEVICE_ORIGIN_SUBSYSTEM:
            draft.subsystem.originDevice = action.device
            return draft

        default:
            return draft
    }
})
export default silUpdateReducer
